export default {
  state: {
    flagFilters: {
      released: null,
      deleted: null,
      expired: null
    },
  },
  mutations: {
    setFlagFilters (state, filters) {
      state.flagFilters = filters;
    },
  },
  actions: {
    setFlagFilters (context, {filters}) {
      context.commit('setFlagFilters', filters);
    },
  }
}